"use client";

import React from "react";
import { Footer, Header } from "@/components/partials";
import { Button } from "@/components/ui/button";
import { RotateCw, AlertCircle } from "lucide-react";

export default function ErrorPage({ reset }: any) {
  return (
    <>
      <Header className="bg-primary!" />
      <main className="container mx-auto flex h-[calc(100dvh-80px)] max-w-[620px] flex-col items-center justify-center px-4 lg:h-[calc(100dvh-120px)]">
        <div className="animate-fade-in space-y-8 text-center">
          {/* Visual indicator */}
          <div className="mx-auto flex h-40 w-40 items-center justify-center rounded-full bg-gray-50">
            <AlertCircle className="h-20 w-20 text-gray-600" />
          </div>

          {/* Message */}
          <div className="space-y-4">
            <h2 className="text-3xl font-bold text-gray-900">
              Something Went Wrong
            </h2>
            <p className="text-lg leading-relaxed text-gray-600">
              We&apos;re having trouble loading this page. Please try again.
            </p>
          </div>

          {/* Action buttons */}
          <div className="flex justify-center">
            <Button
              onClick={() => reset()}
              variant="outline"
              className="gap-2 px-6 py-5 font-medium"
            >
              <RotateCw className="h-5 w-5" />
              Retry
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
